import { render, staticRenderFns } from "./ExportationFramePatient.vue?vue&type=template&id=7b8211ba&scoped=true&"
import script from "./ExportationFramePatient.vue?vue&type=script&lang=ts&"
export * from "./ExportationFramePatient.vue?vue&type=script&lang=ts&"
import style0 from "./ExportationFramePatient.vue?vue&type=style&index=0&id=7b8211ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8211ba",
  null
  
)

export default component.exports